import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { Device, from } from '@helpers/media';
import { Background, ContentType } from '@stories/Components/Misc/SectionWrapper/SectionWrapper';
import styled from 'styled-components';
const Dots = styled.div `
  --borderRadius: 8px;

  &[data-variant=${ContentType.Savings}] {
    --activeColour: ${brand.blue.default};
    --inactiveColour: ${brand.blue.light};

    [data-background=${Background.Blue}] & {
      --inactiveColour: ${brand.global.white};
    }
  }

  &[data-variant=${ContentType.Default}] {
    --activeColour: ${brand.green.default};
    --inactiveColour: ${brand.green.light};

    [data-background=${Background.Green}] & {
      --inactiveColour: ${brand.global.white};
    }
  }

  &[data-variant=${ContentType.Intermediaries}] {
    --activeColour: ${brand.blue.navy};
    --inactiveColour: ${brand.global.beige};

    [data-background=${Background.Green}] & {
      --inactiveColour: ${brand.global.white};
    }
  }

  [data-background=${Background.Beige}] & {
    --inactiveColour: ${brand.global.white};
  }

  display: flex;
  align-items: stretch;
  border-radius: var(--borderRadius);
  background-color: var(--inactiveColour);
  height: 4px;
  width: 100%;

  @media ${from(Device.DesktopSmall)} {
    min-width: 128px;
  }
`;
const Dot = styled.span `
  ${transition('max-width')};

  display: block;
  max-width: var(--progress, 0px);
  width: 100%;
  height: 100%;
  border-radius: var(--borderRadius);
  background-color: var(--activeColour);

  &[data-active='true'] {
    max-width: var(--dotActiveWidth);
  }
`;
export const DotsStyles = {
    Dot,
    Dots,
};
